export default "__VITE_ASSET__DJbnXWN2__"